import { useProjectStore } from "@/stores/projectStore";
import { StarIcon as OutlineStarIcon } from "@heroicons/react/24/outline";
import { StarIcon as SolidStarIcon } from "@heroicons/react/24/solid";

import React from "react";
import { useNavigate } from "react-router-dom";

// Types for the card data
interface ProjectCardProps {
  id: string;
  title: string;
  subTitle: string;
  logo: string;
  isSelected?: boolean;
  isFavorited?: boolean;
  toggleFavorite?: () => void;
}

const ProjectCard: React.FC<ProjectCardProps> = ({
  id,
  title,
  subTitle,
  logo,
  isSelected = false,
  isFavorited,
  toggleFavorite,
}) => {
  const { setSelectedProject } = useProjectStore();
  const navigate = useNavigate();

  const handleCardClick = async (projectId: string) => {
    setSelectedProject(projectId); // Set selected project
    await navigate("/jeuneInnovateur/mesProjets/singleProjet");
  };

  return (
    <div
      onClick={() => handleCardClick(id)}
      className={`flex items-center justify-between p-4 border rounded-2xl shadow-sm ${
        isSelected ? "border-black shadow-lg" : "border-gray-200"
      }`}
    >
      {/* Left: Logo and Text */}
      <div className="flex items-center space-x-3">
        {/* Logo */}
        <div className="w-10 h-10 flex items-center justify-center bg-gray-200 rounded-xl">
          <img src={logo} alt={title} className="w-6 h-6" />
        </div>

        {/* Text */}
        <div>
          <span className="text-xl font-medium text-gray-800">{title}</span>
          <p className="text-sm text-gray-500">{subTitle}</p>
        </div>
      </div>

      {/* Right: Favorite Icon */}
      <div
        className="flex items-center space-x-2"
        onClick={(e) => e.stopPropagation()}
      >
        {isFavorited ? (
          <button onClick={toggleFavorite}>
            <span className="text-gray-400 hover:text-black">
              <SolidStarIcon className="h-8 w-8 text-rajapiYellow" />
            </span>
          </button>
        ) : (
          <button onClick={toggleFavorite}>
            <span className="text-yellow-500 text-lg">
              <OutlineStarIcon className="h-8 w-8 text-rajapiGray" />
            </span>
          </button>
        )}
      </div>
    </div>
  );
};

export default ProjectCard;
